var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0928 9.91037V6.56986C11.0928 5.31813 12.4418 4.57151 13.4489 5.26585L21.3252 10.696C22.2249 11.3163 22.2249 12.6837 21.3252 13.304L13.4489 18.7341C12.4418 19.4285 11.0928 18.6819 11.0928 17.4301V14.0896L4.3561 18.7341C3.34899 19.4285 2 18.6819 2 17.4301V6.56986C2 5.31813 3.34899 4.57151 4.3561 5.26585L11.0928 9.91037Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastForward);
export default __webpack_public_path__ + "static/media/fast-forward.9e1836b03c37019c7342fff3385c4246.svg";
export { ForwardRef as ReactComponent };